export enum LoadingItems {
  PORTFOLIO_CONSTRUCTION = 'portfolio-construction',
  ITEM_UNDER_ANALYSIS_DATE = 'item-under-analysis-date',
  MY_LAB_FETCH_MORNINGSTAR_DATA = 'my-lab-fetch-morningstar-data',
  AI_REPORT_PDF_DOWNLOAD = 'ai-report-pdf-download',
}
